import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 7;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'gl-overview',
      title: `General Ledger <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'The General Ledger is the most detailed report \u2014 showing every transaction grouped by account. Use it for audits, detailed analysis, or drilling into specific account activity.',
      attachTo: { element: '[data-tour="gl-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'gl-open-filters',
      title: `Open Filters <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Open the filter panel to narrow your view by account, fund, contact, label, date range, or amount.',
      attachTo: { element: '[data-tour="gl-customize-btn"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Open Filters',
          classes: 't3-shepherd-next-btn',
          action() {
            const btn = document.querySelector('[data-tour="gl-customize-btn"]');
            if (btn) btn.click();
            setTimeout(() => this.next(), 300);
          },
        },
      ],
    },
    {
      id: 'gl-filter-options',
      title: `Filter Options <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Choose which accounts, funds, contacts, and labels to include. The <strong>AND/OR toggle</strong> controls filter logic: AND means transactions must match ALL filters, OR means they can match ANY filter.',
      attachTo: { element: '[data-tour="gl-customize-drawer"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'gl-amount-filter',
      title: `Amount Range <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Use the amount range filter to find transactions within a specific dollar range \u2014 useful for finding large transactions or reconciling specific amounts.',
      attachTo: { element: '[data-tour="gl-amount-filter"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Close Filters',
          classes: 't3-shepherd-next-btn',
          action() {
            const btn = document.querySelector('[data-tour="gl-customize-btn"]');
            if (btn) btn.click();
            setTimeout(() => this.next(), 300);
          },
        },
      ],
    },
    {
      id: 'gl-filter-pills',
      title: `Active Filters <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'Active filters show as removable pills below the report title. Click the X on any pill to remove that filter. The report updates instantly.',
      attachTo: { element: '[data-tour="gl-filter-pills"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'gl-collapse-rows',
      title: `Expand & Collapse <span class="t3-shepherd-step-count">${stepCounter(6)}</span>`,
      text: 'Click the arrow next to any account header to expand or collapse its transactions. <strong>Collapsed sections show the account total \u2014 debits, credits, and net movement \u2014 automatically summing all underlying transactions.</strong>',
      attachTo: { element: '[data-tour="gl-collapse-row"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'gl-export',
      title: `Export Options <span class="t3-shepherd-step-count">${stepCounter(7)}</span>`,
      text: 'Export as PDF or Excel. For large reports, Excel exports may take a moment \u2014 T3 Books processes them in the background and includes all filtered data.',
      attachTo: { element: '[data-tour="gl-export-buttons"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'generalLedger',
  pathPattern: '/reports/general-ledger',
  getSteps,
  label: 'General Ledger Tour',
});
